/**
 * 2019-04-11
 * handan
 * 支付组件
 */

import React, { Component,Fragment } from 'react'
import { connect } from "react-redux";
import "./style.scss"

import { Checkbox } from "antd";
import { queryWithPoints, getVipVerifyResultData } from "../../models";

class ToPay extends Component{
  constructor(props){
    super(props)
    this.priceSum = {};
    this.onClickPay = this.onClickPay.bind(this);
    this.handleQueryWithPoints = this.handleQueryWithPoints.bind(this);
    this.popDataParamsGood = this.popDataParamsGood.bind(this);
    this.popDataParamsBad = this.popDataParamsBad.bind(this);
  }
  point(){
    let priceSum = this.priceSum;
    return (
      <Fragment>
        <button className="btn" onClick={this.onClickPay}>支付查看</button>
        <div className="content point">
          <div className="prompt">
            <p className="top">已选<em>{priceSum.num}</em>项</p>
          </div>
          <div className="nowPrice">合计：{priceSum.costPoints}点</div>
        </div>
      </Fragment>
    )
  }
  cash(){
    let priceSum = this.priceSum;
    let flag = priceSum.num>=3;
    return (
      <Fragment>
        <button className="btn" onClick={this.onClickPay}>支付查看</button>
        <div className="content">
          <div className="prompt">
            <p className="top">已选<em>{priceSum.num}</em>项<span></span></p>
            <p className="bottom">
              {/* <em>{flag && "6折"}</em> */}
              {/* <span className="oldPrice">原价¥{priceSum.originalPrice}</span> */}
            </p>
          </div>
          <div className="nowPrice">¥{priceSum.salePrice.toFixed(2)}</div>
        </div>
      </Fragment>
    )
  }
  notselected(){
    const { pointSum=0 } = this.props;
    return (
      <Fragment>
        <button className="btn notselected">支付查看</button>
        <div className="content notselected">
          <div className="prompt">
            <p className="top">请选择背调服务
            {
              pointSum<=0 && <span></span>
            }
            </p>
          </div>
        </div>
      </Fragment>
    )
  }
  render(){
    const { pointSum=0, checkedList=[], plainOptions=[],verifyDataList=[],vipInfo=0  } = this.props;
    let checked = plainOptions.length===checkedList.length;
    let isSelected = checkedList.length!==0;
    let isPoint = pointSum>0;
    this.priceSum = this.countPrice(checkedList,verifyDataList,vipInfo.amount);
    if(this.priceSum.num>=3){
      let salePrice = parseInt(this.priceSum.originalPrice*0.6*100)/100;
      this.priceSum.salePrice = salePrice;
    }
    return (
      <div className="ToPay-wrap">
        <div className="container">
          { this.authStatus( verifyDataList ) && <div className="checkbox">
            <span><Checkbox checked={checked} onChange={(e)=>{this.onCheckedChange(e.target.checked)}}></Checkbox></span>全选
          </div> }
          
          { !isSelected && this.notselected() }
          { isSelected && isPoint && this.point() }
          { isSelected && !isPoint && this.cash() }
        </div>
      </div>
    )
  }

  onClickPay(){
    const { pointSum=0, checkedList=[], batchId, setPopData, vipItems = [], getDataCallback, setLoadingState } = this.props;
    let priceSum = this.priceSum;
    let params = {
      batchId,
      clientType: 2,
      costPoint: priceSum.costPoints,
      itemArr: checkedList,
      orderMoney: priceSum.salePrice,
      payType: pointSum >= priceSum.costPoints ? 1 : 2,
    }
    if(this.getTheSame(vipItems,checkedList)){
      setLoadingState(true);
      getVipVerifyResultData(params).then(()=>{

        setLoadingState(false);
        getDataCallback();
        this.popDataParamsGood(`您已成功消耗${checkedList.length}次会员权益`);

      }).catch(()=>{
        
        setLoadingState(false);
        this.popDataParamsBad();

      })
      return ;
    }
    if (pointSum >= priceSum.costPoints) {
      // 点够，直接点支付
      this.handleQueryWithPoints(params);
    } else {
      // 点不够或没有点，用钱支付
      setPopData({
        isShowModal: true, // 打开弹框
        isPayModal: true, // 是否使用充值的弹框
        pointSum,
        originalPrice: priceSum.originalPrice,
        params,
      })
    }
  }

  // 点支付
  handleQueryWithPoints(params){
    const { setLoadingState, getDataCallback } = this.props;
    let priceSum = this.priceSum;
    setLoadingState(true);
    queryWithPoints(params).then((res) => {

      setLoadingState(false);
      getDataCallback();
      this.popDataParamsGood(`您已成功支付${priceSum.costPoints}点`);
      // this.props.history.push('/resultHistory')
    }).catch(() => { 

      setLoadingState(false);
      this.popDataParamsBad();

    })
  }

  // 全选
  onCheckedChange(flag){
    const { setCheckedList, plainOptions=[] } = this.props;
    let checkedList = flag ? plainOptions : [];
    setCheckedList(checkedList)
  }

  // 支付成功弹框
  popDataParamsGood(text){
    const { setPopData } = this.props;
    let popData = {
      isShowModal: true,
      isPayModal: false,
      isSuccess: true,
      isOk: true,
      data: {
        title: text,
        text:'系统已发授权短信给候选人，短信以【58同城】开头且带有授权网址。需对方打开网址同意授权后查看背调结果。授权24小时有效，请告知对方及时授权，点击【确定】后进入调查进度',
        buttonText: "确定"
      }
    }
    setPopData(popData);
  }

  // 支付失败弹框
  popDataParamsBad(){
    const { setPopData } = this.props;
    let popData = {
      isShowModal: true,
      isPayModal: false,
      isSuccess: false,
      data: {
        title: "支付失败",
        text: `请检查网络或重新支付`,
        buttonText: "关闭"
      }
    }
    setPopData(popData);
  }

  // 计算价格
  countPrice(checkedList,data,vipTime){
    let sum = {
      salePrice: 0,
      originalPrice: 0,
      costPoints: 0,
      num: checkedList.length,
    };
    for(var i=0;i<checkedList.length;i++){
      for(var j=0;j<data.length;j++){
        if(checkedList[i]===data[j].itemId){
          let flag = data[j].canUseVip && vipTime>0 ;
          sum.salePrice += flag ? 0 : data[j].salePrice; // 现价
          sum.originalPrice += flag ? 0 : data[j].originalPrice; // 原价
          sum.costPoints += flag ? 0 : data[j].costPoints; // 点
          break;
        }
      }
    }
    return sum;
  }
  // 判断是否有待授权
  authStatus(data){
    let flag = true;
    if( data && data.length > 0  ){
        data.map(item=>{
          if( item.authStatus == 1 ){
            flag = false;
          }
        })
    }
    return flag;
  }

  // 判断两个数组项是否相同
  getTheSame(vipItems,checkedList){
    if(vipItems.length !== checkedList.length){
      return false;
    }
    for(var i=0; i<vipItems.length;i++){
      let index = checkedList.indexOf(vipItems[i]);
      if(index===-1){
        return false
      }
    }
    return true;
  }

}

const mapState = (store)=>{
  return {
    plainOptions: store.verifyResult.plainOptions,
    checkedList: store.verifyResult.checkedList,
    pointSum: store.verifyResult.pointSum,
    verifyDataList: store.verifyResult.verifyDataList,
    vipInfo: store.verifyResult.vipInfo,
  }
}
const mapDispatch = (dispatch)=>{
  return {
    setCheckedList(data){
      dispatch({
        type: "setCheckedList",
        data,
      })
    },
    setPopData(data){
      dispatch({
        type: "setPopData",
        data,
      })
    },
    setLoadingState(data){
      dispatch({
        type: "setLoadingState",
        data
      })
    },
  }
}
export default connect(mapState,mapDispatch)(ToPay);